import { UserRole } from "../transports/user";

export const CheckRoles = {
    isLeadBussinessOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_BUSINESS_MANAGER ||
            currentRole == UserRole.ROLE_BUSINESS_MANAGER
        );
    },

    isLeadProofreaderOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_PROOFREADER ||
            currentRole == UserRole.ROLE_PROOFREADER
        );
    },

    isLeadWriterOrUnder: (currentRole?: UserRole) => {
        return currentRole == UserRole.ROLE_LEAD_WRITER || currentRole == UserRole.ROLE_WRITER;
    },

    isLeadProjectManagerOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
            currentRole == UserRole.ROLE_PROJECT_MANAGER
        );
    },

    isLeadLinkerAndLinker: (currentRole?: UserRole) => {
        return currentRole == UserRole.ROLE_LEAD_LINKER || currentRole == UserRole.ROLE_LINKER;
    },

    isManager: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
            currentRole == UserRole.ROLE_PROJECT_MANAGER ||
            currentRole == UserRole.ROLE_BUSINESS_MANAGER ||
            currentRole == UserRole.ROLE_LEAD_BUSINESS_MANAGER ||
            currentRole == UserRole.ROLE_ADMIN
        );
    },

    isAdminAndLeadBussinessOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_BUSINESS_MANAGER ||
            currentRole == UserRole.ROLE_BUSINESS_MANAGER ||
            currentRole == UserRole.ROLE_ADMIN
        );
    },

    isAdminAndLeadProofreaderOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_PROOFREADER ||
            currentRole == UserRole.ROLE_PROOFREADER ||
            currentRole == UserRole.ROLE_ADMIN
        );
    },

    isAdminAndLeadWriterOrUnder: (currentRole?: UserRole) => {
        return (
            currentRole == UserRole.ROLE_LEAD_WRITER ||
            currentRole == UserRole.ROLE_WRITER ||
            currentRole == UserRole.ROLE_ADMIN
        );
    },

    isLead: (currentRole?: UserRole) => {
        return currentRole?.includes("_LEAD_") || currentRole == UserRole.ROLE_ADMIN;
    },

    isAdmin: (currentRole?: UserRole) => {
        return currentRole == UserRole.ROLE_ADMIN;
    },
};
